import { Card, Flex, Input, Upload, Spin } from "antd";
import React, {
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  SendOutlined,
  UploadOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import "./MessageInput.scss";
import { sendMessage } from "../../../api/Chat";
import { v4 as uuid } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { sendChatMessage, uploadDocument } from "../../../assets/api/collecteazeAi";
import { appendCurrentMessage, fetchSessionsMessages } from "../../../store/collecteazeAiSlice";

const MessageInput = forwardRef(({ onSend, isLoading = false, setIsLoading }, ref) => {
  const [isActive, setIsActive] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [text, setText] = useState("");
  const { current_session } = useSelector(state => state.collecteazeAi)
  const { token, user } = useSelector(state => state.auth);
  const inputRef = useRef(null);

  // Expose focusInput method to parent via ref
  useImperativeHandle(ref, () => ({
    focusInput: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
  }));

  

  const handleFileChange = async({ fileList }) => {
    
    setFileList(fileList);
  
     const res = await uploadDocument({
      files:fileList[0]?.originFileObj,
      session_id:current_session
    },token)
   
   if(res?.status === 200) {
    dispatch(fetchSessionsMessages({ session_id: current_session }));
   }
  };

  const uploadButton = (
    <UploadOutlined
      style={{
        fontSize: 20,
        color: "#3E97FF",
        cursor: isLoading ? "not-allowed" : "pointer",
      }}
    />
  );
  const dispatch = useDispatch();

  const handleSend = async () => {
    if (!text.trim()) return; // prevent sending empty messages

    // Create user message
    const userMessage = [
      {
        message_id: uuid(),
        role: "user",
        timestamp: new Date().toISOString(),
        message: text,
      },
      {
        message_id: uuid(),
        role: "bot",
        timestamp: new Date().toISOString(),
        message: 'We encountered an issue. Please refresh or try again.',
        is_dummy: true
      },
    ]

    // Clear input and update UI optimistically
    setText('');
    dispatch(appendCurrentMessage(userMessage));
    setIsLoading(true)

    try {
      // Send message to backend
      const res = await sendChatMessage(
        {
          session_id: current_session,
          user_id: user?.email,
          message: text,
        },
        token
      );

      // Fetch updated messages only if successful
      if (res?.status === 200) {
        dispatch(fetchSessionsMessages({ session_id: current_session }));
        setIsLoading(false)
      } else {
        setIsLoading(false)

      }
    } catch (error) {
     
      setIsLoading(false)

    }
  };

  return (
    <Flex className="inputContainer">
      <Card className="promptWrapper">
        <Flex
          className="inputWrapper"
          style={{
            padding: 10,
            borderRadius: 24,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            width: "100%",
            margin: "auto",
            background: "#F6F9FC",
            padding: 20,
            borderRadius: isActive ? 10 : 24,
            border: isActive ? "1px solid #3E97FF" : "none",
            boxShadow: isActive
              ? "0px 0px 17px 0px rgba(62, 151, 255, 0.20)"
              : "0 4px 12px rgba(0,0,0,0.1)",
            width: "100%",
            maxWidth: 934,
            margin: "auto",
          }}
          gap="small"
          align="center"
        >
          {/* Upload file feature */}
          <Upload
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={() => false}
            showUploadList={false}
            disabled={isLoading}
            style={{ marginRight: 10 }}
            maxCount={1}
          >
            {uploadButton}
          </Upload>

          {fileList?.length > 0 && (
            <CheckCircleFilled
              style={{ color: "#52c41a", fontSize: 20, marginLeft: 4 }}
            />
          )}

          <Input
            ref={inputRef}
            placeholder="Ask Me Something..."
            bordered={false}
            style={{ flex: 1 }}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onFocus={() => setIsActive(true)}
            onBlur={() => setIsActive(false)}
            onPressEnter={handleSend}
            disabled={isLoading}
          />

          <SendOutlined
            style={{ cursor: "pointer" }}
            onClick={handleSend}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            aria-label="Send message"
          />
        </Flex>
      </Card>
    </Flex>
  );
});

export default MessageInput;
